/**
 * Transforms a Cloudinary delivery URL to request a specific size/crop on the fly.
 * Safe no-op for any URL that isn't a recognizable Cloudinary upload URL (e.g. external
 * links pasted directly into the image field) — those are returned unchanged.
 */
export function getOptimizedImageUrl(
  url: string | undefined | null,
  width = 1200,
  height = 630
): string {
  if (!url) {
    return '';
  }

  const marker = '/image/upload/';
  const markerIndex = url.indexOf(marker);

  if (markerIndex === -1) {
    // Not a Cloudinary URL we recognize — return as-is rather than risk breaking it
    return url;
  }

  const insertAt = markerIndex + marker.length;
  const transformation = `w_${width},h_${height},c_fill,q_auto,f_auto/`;

  // Avoid double-inserting if this URL was already transformed somewhere
  if (url.slice(insertAt).startsWith('w_')) {
    return url;
  }

  return url.slice(0, insertAt) + transformation + url.slice(insertAt);
}